<script setup>
/**
 * KaptionChatPreferencesButton
 *
 * Gear button that opens the "Chat preferences" popover — the settings that
 * used to sit at the bottom of the topbar's filter menu. Shown in the
 * conversation list header (opens downward) and next to the reply box's
 * maximize button (opens upward, since the reply box is at the bottom).
 *
 * NOTICE: KAPTION-INTEGRATION
 */
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import NextButton from 'dashboard/components-next/button/Button.vue';
import KaptionChatPreferencesPanel from './KaptionChatPreferencesPanel.vue';

const props = defineProps({
  direction: {
    type: String,
    default: 'down',
    validator: v => ['down', 'up'].includes(v),
  },
});

const { t } = useI18n();
const isOpen = ref(false);

function close() {
  isOpen.value = false;
}

function toggle() {
  isOpen.value = !isOpen.value;
}
</script>

<template>
  <div v-on-clickaway="close" class="relative" @keydown.esc.stop="close">
    <NextButton
      v-tooltip.top-end="t('KAPTION_PLATFORM.PREFERENCES.TITLE')"
      :aria-label="t('KAPTION_PLATFORM.PREFERENCES.TITLE')"
      :aria-expanded="isOpen"
      data-testid="kaption-chat-preferences-button"
      icon="i-lucide-settings"
      slate
      xs
      :ghost="!isOpen"
      :faded="isOpen"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      class="absolute z-50 overflow-hidden border rounded-xl shadow-lg bg-n-solid-1 border-n-weak"
      :class="
        props.direction === 'up'
          ? 'bottom-full mb-2 ltr:right-0 rtl:left-0'
          : 'top-full mt-2 ltr:-right-10 rtl:-left-10'
      "
    >
      <KaptionChatPreferencesPanel />
    </div>
  </div>
</template>
